import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MaintenanceBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/maintenance/feature","featureId":"common-maintenance"},
      bundledItemModels: ["MaintenanceSettingsItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users'],
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MaintenanceFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MaintenanceFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MaintenanceBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MaintenanceBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {},
        admin: {
          maintenance: () => '/maintenance'
        }
      }
    };
  }
}